/**
 * @module Theme
 */

import { Component, Input } from '@angular/core';
import { ItemColor } from '@functions/item.functions';
import { ThemeOptionsClass } from '@class/themeOptions.class';
import { ThemeOptionType } from '@models/themeStudio.model';

@Component({
  selector: 'app-theme-option-tooltips-body-font-size',
  templateUrl: './theme-option-tooltips-body-font-size.component.html',
  styleUrls: ['./theme-option-tooltips-body-font-size.component.css']
})
export class ThemeOptionTooltipsBodyFontSizeComponent {

  @Input() themeOptions: ThemeOptionsClass;

  color = ItemColor('themes');
  optionType: ThemeOptionType = 'tooltips_bodyFontSize';

  constructor() {}
  
  receiveValue(value: number) {
    this.themeOptions.setOption('tooltips_bodyFontSize', value);
  }

}
